import React, { useEffect, useRef, useState } from "react";

import { Icon } from "@culturehq/components";

import LazyInputRange from "components/survey/item-types/LazyInputRange";
import { useTimelineScale } from "../../contexts/TimelineScaleContext";

interface TimelineZoomProps {
  initialZoom: number;
}

const TimelineZoom: React.FC<TimelineZoomProps> = ({ initialZoom }) => {
  const { setTimelineScale } = useTimelineScale();

  const [zoom, setZoom] = useState(100);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(
    () => {
      setZoom(initialZoom);
      setTimelineScale(initialZoom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialZoom]
  );

  const handleScale = (value: number) => {
    setZoom(value);
    setTimelineScale(value);
  };

  return (
    <div className="TimelineZoom-Container" ref={containerRef}>
      <div className="TimelineZoom-Slider">
        <Icon
          className="MinusIcon"
          onClick={() => {
            handleScale(Math.max(zoom - 10, 10));
          }}
          icon="zoom-out"
        />
        <LazyInputRange
          maxValue={150}
          minValue={10}
          value={zoom}
          onChange={handleScale}
        />
        <Icon
          className="PlusIcon"
          onClick={() => {
            handleScale(Math.min(zoom + 10, 150));
          }}
          icon="zoom"
        />
      </div>
    </div>
  );
};

export default TimelineZoom;
